import { useState } from 'react';
import { Button } from '@components/primitives/Button';
import {
  getReferralRewardText,
  HowReferralsWorkModal,
  useCopyReferralLink,
  useReferralsQuery,
} from '@features/referrals';
import { Box, Link, Typography } from '@mui/material';

/**
 * Compact referral invite banner for the dashboard header.
 * Shown to active subscribers (replaces TrialBanner).
 */
export const ReferralInviteBanner = () => {
  const { data, isLoading } = useReferralsQuery();
  const { copyLink } = useCopyReferralLink();
  const [modalOpen, setModalOpen] = useState(false);

  const referralCode = data?.referral_code;
  const rewardText = getReferralRewardText(data?.referrer_reward_amount, data?.signup_discount_amount);

  const handleCopyLink = async () => {
    if (!referralCode) return;
    await copyLink(referralCode, 'dashboard_header');
  };

  // Don't show if loading or no referral code
  if (isLoading || !referralCode) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
              fontSize: { xs: '0.875rem', sm: '0.9375rem' },
              lineHeight: 'normal',
            }}
          >
            {rewardText.headline}
          </Typography>
          <Link
            component="button"
            variant="caption"
            onClick={() => setModalOpen(true)}
            sx={{ color: 'text.secondary', lineHeight: 'normal' }}
          >
            How referrals work
          </Link>
        </Box>

        <Button variant="contained" color="secondary" onClick={handleCopyLink}>
          Copy Referral Link
        </Button>
      </Box>

      <HowReferralsWorkModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        referralCode={referralCode}
        referrerRewardAmount={data?.referrer_reward_amount}
        signupDiscountAmount={data?.signup_discount_amount}
      />
    </>
  );
};
